import axios from 'axios';
import jsonp from 'jsonp';
import Cookies from 'js-cookie';

export default {
  state: {
    userInfo: null,
    iframeSrc: '',
    isLogin: false,
    showLogin: false,
    returnUrl: '',
  },
  mutations: {
    setUserInfo(state, data) {
      state.userInfo = data;
      state.isLogin = true;
    },
    setIframeSrc(state, data) {
      state.iframeSrc = data;
    },
    setShowLogin(state, data) {
      state.showLogin = data;
    },
    setReturnUrl(state, data) {
      state.returnUrl = data;
    },
  },
  actions: {
    async getUserInfo({ dispatch, commit, state }) {
      const isWx = /MicroMessenger/i.test(navigator.userAgent.toLowerCase());
      if (isWx) {
        await dispatch('getWxUserInfo');
        return;
      }
      const getCode = () => new Promise((resolve, reject) => {
        jsonp('https://passport.aidalan.com/v1/passport/checkLoginState', (err, data) => {
          if (err) {
            this.$Message.error('网络错误，请检查网络！');
            reject(err);
          }
          resolve(data);
        });
      });
      const accessToken = Cookies.get('access_token');
      let result;
      if (accessToken) {
        result = await axios.post('/api/tokenExchangeUserInfo', {
          access_token: accessToken,
        });
      } else {
        const codeRes = await getCode();
        if (codeRes.ret === 1) {
          result = await axios.post('/api/codeExchangeUserInfo', {
            authorize_code: codeRes.content.authorize_code,
          });
        }
      }
      if (result && result.data.ret === 1) {
        const { content } = result.data;
        commit('setUserInfo', content);
      } else {
        commit('setIframeSrc', `https://passport.aidalan.com/v1/passport/index?
        mobile=&union_app_id=100000341&redirect_url=${state.returnUrl}`);
      }
    },
    async getWxUserInfo({ commit }) {
      const url = location.href;
      let code = '';
      if (url.indexOf('code') !== -1) {
        const sUrl = location.search.substring(1);
        const aSUrl = sUrl.split('&');
        aSUrl.forEach((item) => {
          const aItem = item.split('=');
          if (aItem[0] === 'code') {
            code = aItem[1];
          }
        });
      }
      // const origin = location.href;
      if (code && localStorage.code !== code) {
        const wxRes = await axios.post('/api/getWeixinUserInfo', {
          code,
        });
        if (wxRes && wxRes.data.ret === 1) {
          const { content } = wxRes.data;
          commit('setUserInfo', content);
          localStorage.code = code;
          localStorage.wxUserInfo = window.JSON.stringify(content);
        }
      } else if (code && localStorage.code === code) {
        commit('setUserInfo', window.JSON.parse(localStorage.wxUserInfo));
      } /* else {
        location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize' +
          `?appid=wx9a4d88af45e29c4b&redirect_uri=${origin}` +
          '&response_type=code&scope=snsapi_base&state=hd123#wechat_redirect';
      } */
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/login.js